import { useEffect } from 'react';

export const useFirewallPoliciesStatusData = getFirewallPoliciesStatusRequest => {
    useEffect(() => {
        const timer = setInterval(() => getFirewallPoliciesStatusRequest(), 1.8e6);

        return () => clearInterval(timer);
    }, []);
};
